import { render } from "./ChatbotList.vue?vue&type=template&id=16be1f51&scoped=true"
import script from "./ChatbotList.vue?vue&type=script&lang=js"
export * from "./ChatbotList.vue?vue&type=script&lang=js"

import "./ChatbotList.vue?vue&type=style&index=0&id=16be1f51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16be1f51"]])

export default __exports__